import {
  BrowserIntegrations,
  requiresTrackingReload,
} from '@/platform/analytics/BrowserIntegrations'
import type { NextPageWithLayout } from '@/shared/page'
import { globalStyles } from '@/shared/styles/global'
import { ToastViewport } from '@/shared/ui/Toast/styles'
import * as Toast from '@radix-ui/react-toast'
import type { AppProps } from 'next/app'
import { useRouter } from 'next/router'
import { Fragment } from 'react'
import '@/modules/envio-documentos/styles.scss'
import '@/shared/styles/fonts.css'

globalStyles()

export default function App({
  Component,
  pageProps,
}: AppProps & { Component: NextPageWithLayout }) {
  const router = useRouter()
  const getLayout = Component.getLayout || ((page) => page)
  const FlowProvider = Component.FlowProvider || Fragment
  return (
    <Toast.Provider
      swipeDirection="right"
      label="Notification"
      duration={Component.toastDuration ?? 10000}
    >
      {!requiresTrackingReload(Boolean(Component.integrations?.hotjar)) && (
        <FlowProvider>{getLayout(<Component {...pageProps} />)}</FlowProvider>
      )}
      <ToastViewport placement={Component.toastPlacement ?? 'support'} />
      <BrowserIntegrations {...Component.integrations} path={router.asPath} />
    </Toast.Provider>
  )
}
